import { createStyles, makeStyles, Theme } from "@material-ui/core";
import { useAuth } from "auth";
import { Roles } from "Enums/Roles";
import React, { FC } from "react";
import { CurrentScoreCompareChart } from "Views/Components/ManagementSummary/CurrentScoreCompareChart";
import { ScoreVsTimeChart } from "Views/Components/ManagementSummary/ScoreVsTimeChart";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 1,
      width: "100%",
      paddingBottom: theme.spacing(1),
    },
  }),
);

export const GraphicalResults: FC = () => {
  const classes = useStyles();
  const { auth } = useAuth();

  return (
    <>
      {(auth?.hasRealmRole(Roles.auditor) ||
        auth?.hasRealmRole(Roles.administrator) ||
        auth?.hasRealmRole(Roles.agency) ||
        auth?.hasRealmRole(Roles.agency_v2)) && (
        <>
          <div className={classes.root}>
            <CurrentScoreCompareChart />
          </div>
          <div className={classes.root}>
            <ScoreVsTimeChart />
          </div>
        </>
      )}
    </>
  );
};
